/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { TextField, InputAdornment, useTheme } from "@mui/material";
import { SearchIcon } from "~components/Icons";
import { useRealtimeProductsContext } from "~contexts/RealtimeProducts";
import { useProductsContext } from "~contexts/Products";
import useDebounce from "~hooks/useDebounce";
import type { Product as IProduct } from "~api/stream/interfaces";

const StreamSearch = () => {
  const theme = useTheme();
  const { searchTerm, setSearchTerm, setProductList } =
    useRealtimeProductsContext();
  const { getAllProductsFromCache, loadedProductsFromSheet, buttons } =
    useProductsContext();
  const debounceSearchTerm = useDebounce(searchTerm);

  const initialProductList = useMemo(() => {
    // Usar os produtos já carregados no cache de categorias (todas as categorias)
    const allProducts = getAllProductsFromCache();
    if (!allProducts || !allProducts.length) {
      return [];
    }
    return allProducts;
  }, [getAllProductsFromCache, loadedProductsFromSheet, buttons.length]);

  useEffect(() => {
    if (!initialProductList) return;

    if (!debounceSearchTerm || debounceSearchTerm.length < 3) {
      setProductList(initialProductList);
    } else {
      const normalizedSearch = debounceSearchTerm
        .toLowerCase()
        .normalize("NFD")
        .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");

      const filteredProducts = initialProductList.filter((product: IProduct) => {
        const name = (product.productName || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");

        const id = String(product.provider?.productId || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");

        return name.includes(normalizedSearch) || id.includes(normalizedSearch);
      });

      setProductList(filteredProducts);
    }
  }, [initialProductList, debounceSearchTerm, setProductList]);


  return (
    <TextField
      variant="outlined"
      fullWidth
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="buscar produtos"
      hiddenLabel
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="end"
            sx={{
              mr: 0,
              ml: theme.spacing(1.25),
              mt: theme.spacing(1),
              color: "transparent",
            }}
          >
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{
        "& input::placeholder": {
          color: theme.palette.grey[800],
          fontSize: "16px",
        },
      }}
    />
  );
};

export default StreamSearch;
